import { useCallback, useEffect, useRef, useState } from 'react'

const DOCK_TOP_INSET_PX = 64

function findScrollParent(element: HTMLElement | null): HTMLElement | null {
  let node = element?.parentElement ?? null

  while (node) {
    const { overflowY } = window.getComputedStyle(node)
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      return node
    }
    node = node.parentElement
  }

  return null
}

export function useInstallationCardDock(installationCardKey: string) {
  const installationRef = useRef<HTMLDivElement>(null)
  const [showDock, setShowDock] = useState(false)

  useEffect(() => {
    setShowDock(false)
  }, [installationCardKey])

  useEffect(() => {
    const target = installationRef.current
    if (!target) return

    const scrollRoot = findScrollParent(target)
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return
        setShowDock(!entry.isIntersecting)
      },
      {
        root: scrollRoot,
        rootMargin: `-${DOCK_TOP_INSET_PX}px 0px 0px 0px`,
        threshold: 0,
      }
    )

    observer.observe(target)

    return () => observer.disconnect()
  }, [installationCardKey])

  const scrollToInstallation = useCallback(() => {
    const scrollRoot = findScrollParent(installationRef.current)
    scrollRoot?.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return { installationRef, showDock, scrollToInstallation }
}
